<template>
    <div class="xl-container">
        <div @click="navigateTo(item.jump_time)" v-for="item in vector_result" class="list">
            <div class="left-container">
                <img :src="item.img_url || defaultImg" alt="">
            </div>
            <div class="right-container">
                <div class="t">{{item.time_range}} {{item.duration}}</div>
                <div class="b">{{item.confidence_rate}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";

export default {
    name: 'newMaterialXl',
    data() {
        return {
            articleValue: '',
            pageIndex: 1,
            pageSize: 30,
            list: [],
            totalNum: 0,
            showResult: false,
            defaultImg: require("@assets/img/common/default.png")
        }
    },
    props: {
        vector_result: {
            type: Array
        }
    },
    methods: {
        navigateTo(to) {
            this.$emit('toTime',to*100)
        }
    },
    mounted() {
        console.log(this.vector_result)   
    }
}
</script>

<style lang="less" scoped>
    .xl-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 14px 20px;
        box-sizing: border-box;
        overflow-y: auto;

        .list {
            display: flex;
            align-items: center;
            width: 100%;
            margin-bottom: 20px;

            .left-container {
                margin-right: 20px;
                width: 120px;
                height: 68px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .right-container {
                display: flex;
                flex-direction: column;
                height: 100%;
                justify-content: space-between;
                padding: 5px 0;
                box-sizing: border-box;

                .t {
                    font-size: 14px;
                }

                .b {
                    font-size: 14px;
                }
            }
        }

        .result {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 18px;

            i {
                display: block;
                width: 6px;
                height: 6px;
                background: #B9C3C3;
                border-radius: 50%;
                margin-right: 8px;
            }

            p {
                font-size: 13px;
                line-height: 18px;
                color: #829191;
                font-weight: 500;
            }
        }

        .articleInput {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            height: 40px;
            background: rgba(207, 215, 219, 0.2);
            border-radius: 6px;
            padding: 0 20px;
            box-sizing: border-box;
            margin-bottom: 20px;

            input {
                width: 100%;
                height: 100%;
                background: transparent;
                font-size: 14px;

                &::placeholder {
                    color: #B9C3C3;
                }
            }

            img {
                user-select: none;
                cursor: pointer;
            }
        }

        ul {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 100%;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-thumb {
                background: rgba(#D8D8D8, 1);
                border-radius: 4px;
            }

            li {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;
                margin-bottom: 16px;
                user-select: none;
                cursor: pointer;

                &:hover {
                    i {
                        display: block;
                        width: 24px;
                        height: 24px;
                        background: url('../../../common/newMaterialBox/assets/littleFileOn.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-right: 10px;
                    }

                    p {
                        color: #41B48C;
                    }
                }

                &.on {
                    i {
                        display: block;
                        width: 24px;
                        height: 24px;
                        background: url('../../../common/newMaterialBox/assets/littleFileOn.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-right: 10px;
                    }

                    p {
                        color: #41B48C;
                    }
                }

                i {
                    display: block;
                    width: 24px;
                    height: 24px;
                    background: url('../../../common/newMaterialBox/assets/littleFile.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                }

                p {
                    flex: 1;
                    font-size: 14px;
                    line-height: 20px;
                    color: #050F0F;
                    font-weight: 500;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
</style>

<style lang="less">
.xl-container {
    em {
        color: #41b48c;
        font-style: normal;
    }
}
</style>